(function () {
    const brainTreeLpmForm = {
        lpmForm: $('#brainTreeLpm-form'),
        localBtn: $('.local-payment-method-button'),

        init: function () {
            brainTreeLpmForm.control();
        },
        control: function () {
            // Loop over the local payment methods buttons
            brainTreeLpmForm.localBtn.each((index, elem) => {
                // Create the lpm option container
                const lpmOption = jQuery('<div>', {
                    class: 'braintree-option lpm-option',
                    tabindex: '0',
                    role: 'button',
                });

                const lpmLabel = jQuery('<div>', {
                    class: 'braintree-option__label',
                    'aria-label': 'Giropay',
                });
                // Append the Btn and label to option container
                const labelFromId = elem?.id.split('-')[0] || 'Unknown';
                lpmLabel.text(labelFromId);
                lpmOption.append(elem);
                lpmOption.append(lpmLabel);
                brainTreeLpmForm.lpmForm.parent().addClass('lpm-section braintree-dropin').append(lpmOption);

                // Add Event Listener to the option div
                lpmOption.on('click', () => {
                    lpmOption.off('click');
                    $(elem).trigger('click');
                });
            });
        },
    };
    UX.brainTreeLpmForm = brainTreeLpmForm; // add to global namespace
})();
